export default __webpack_public_path__ + "static/media/Eus.8054fcaa.png";